import { render } from "./ProtokolList.vue?vue&type=template&id=011d4284&scoped=true"
import script from "./ProtokolList.vue?vue&type=script&lang=js"
export * from "./ProtokolList.vue?vue&type=script&lang=js"

import "./ProtokolList.vue?vue&type=style&index=0&id=011d4284&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-011d4284"]])

export default __exports__